/**
 * Directive de formulaire pour l'ajout d'un equipement
 */
app.directive('formAddEquipement', [ 'crudService', '$filter', '$rootScope', 
    function(crudService, $filter, $rootScope) {
        return {
    		restrict: "E",
    		templateUrl: "/templates/partials/directives/forms/equipement/add_equipement.html",
    		scope: {
    			siteid:             '=', // ID du site en cours
                contratid:          '=', // ID du contrat en cours
                categoryid:         '=', // ID de la category / mission : charge des produit uniquement pour cette categ
                associateproductid: '=', // ID du produit : a associer à l'equipement si non false
                hasproducts:         '=', // Si la dropdown des produits doit être présente
    		},
            link: function(scope, element, attrs, tabsCtrl) {
                scope.type_equipement           = null;  // type d'equipement selectionné dans la dropdown
                scope.type_equipement_loaded    = true;
                scope.messages_error            = [];    // Erreurs formulaire
                scope.submit_loaded             = true;  // formulaire chargé : false = en cours de chargement
                scope.editMode                  = false; // Mode edition
                scope.productsWithoutInventaire = [      // Produits non présents dans la dropdown des produits
                    'commission_de_securite',
                    'instruction_du_personnel',
                    'formation_du_personnel',
                    'enregistrement_des_incidents',
                    'plan_evacuation',
                    'issues_de_secours',
                    'equipements_devacuation',
                    'ramonage_des_conduits_de_fumee',
                    'date_autorisation',
                    'visite_reception',
                ];

                /**
                 * init la dropdown de type d'equipement
                 * @return void
                 */
                var initDropDown = function() {
                    scope.type_equipement       = null;
                    scope.type_equipement_loaded= true;
                    $('#caracteristique-inputs-binding', element).html('');

                    $('#type-equip-dropdown').select2({
                        theme: "default",
                        placeholder: $filter('translate')('choisir_type')
                    });

                    $('#type-equip-dropdown').change(function(e) {
                        var value = $(this).val();
                        $('#caracteristique-inputs-binding', element).html(''); // reset des inputs caracteristiques
                        
                        if(value !== null && value !== "" && value !== undefined && scope.equipement !== null && scope.equipement !== undefined) {
                            data = {};
                            if(scope.editMode) {
                                data = {
                                    equipement_id: scope.equipement.id
                                };
                            }
                            
                            // Au changement du type d'equipement
                            scope.type_equipement_loaded = false;
                            crudService.get('types-equipement/' + value, data).then(function(response) {
                                // Recuperation des infos du type d'equipement
                                scope.type_equipement       = response;
                                scope.type_equipement_loaded= true;
                                var has_lists = false;
    
                                angular.forEach(response.caracteristiques, function(caracteristique, key) {
                                    // Binding du formulaire avec les inputs des caracteristiques
                                    var input = '';
                                    input += '<div class="field">';
                                    input += '<label>' + $filter('translate')(caracteristique.slug) + '</label>';
                                    input += caracteristique.html_input;
                                    input += '</div>';
                                    $('#caracteristique-inputs-binding', element).append(input);
    
                                    if(caracteristique.type === 'list') {
                                        has_lists = true;
                                    }
    
                                    // Bind une fonction permettant de changer le label en fonction de la valeur d'une checkbox
                                    $('#'+caracteristique.slug+'_form_checkbox').bind("change", function(e) {
                                        var checked         = $(this).prop("checked"); // Checked ou non
                                        var checkboxLabel   = $(this).siblings('label'); // Récupération du label
                                        var html            = (checked ? $filter('translate')('oui') : $filter('translate')('non')); // Valeur du label
    
                                        checkboxLabel.html(html); // Application de la valeur
                                        $(this).val(checked); // Changement de la valeur de la checkbox
                                    });
                                });
    
                                // Si il y a une liste => mise en place des dropdowns
                                if(has_lists) {
                                    var selects = $('#caracteristique-inputs-binding select', element);
                                    selects.each(function() {
                                        $(this).dropdown({
                                            placeholder: $filter('capitalize')($filter('translate')('aucune_valeur'))
                                        });
                                    });
                                }
                            });
                        }
                    });
                };

                /**
                 * Format serializeArray pour req POST
                 * @param   Array formArray     serializeArray
                 * @param   Array inputsName
                 * @return  Object
                 */
                var formatArrayForm = function(formArray, inputsName) {
                    var data = {};
                    var formArrayInputsName = [];
                    
                    // Récupère tous les noms des inputs du formulaire récupéré avec serializeArray()
                    angular.forEach(formArray, function(formData) {
                        formArrayInputsName.push(formData['name']);
                    });
                    
                    // Pour chaque nom d'input du formulaire
                    angular.forEach(inputsName, function(inputName) {
                        if(formArrayInputsName.indexOf(inputName) === -1) { // Si le nom n'existe pas dans le tableau des noms d'input récupérés avec serializeArray
                            // Ajout de l'input dans le tableau avec comme valeur null (généralement liste vide)
                            formArray.push({
                                'name': inputName,
                                'value': null
                            });
                        }
                    });

                    for (var i = 0; i < formArray.length; i++) {
                        var item = formArray[i];
                        var is_array = item['name'].slice(-2) === '[]';

                        if(is_array) { // Si la clé est un tableau => liste multiple
                            item['name'] = item['name'].slice(0, (item['name'].length-2)); // On enlève [] de la clé
                            if(!Array.isArray(data[item['name']])) { // Si la clé dans data n'est pas un tableau
                                data[item['name']] = []; // Transformation en tableau
                            }
                            
                            data[item['name']].push(item['value']); // Ajout de la valeur au tableau
                        } else { // Sinon
                            data[item['name']]  = item['value']; // Traitement normal
                        }
                    }

                    return data;
                };

                /**
                 * Init des données de la dropdown produit si necessaire
                 * @return Boolean|void
                 */
                scope.allCategsAndProducts = {};
                scope.initProduits = function () {
                    // scope.produit_id_selected = null;
                    if (angular.isUndefined(scope.contratid) && scope.contratid != '') {
                        return false;
                    }
                    
                    var params = {
                        category_id: scope.categoryid
                    };
                    scope.produits_loaded = false;
                    // Recuperation et bind de la dropdown produits
                    crudService.get('contrat/' + scope.contratid + '/products-by-categ', params).then(function(response) {
                        scope.allCategsAndProducts = response;
                        setDropdownProduits();
                        scope.produits_loaded = true;
                    });
                };
                
                /**
                 * Initialise les données de la dropdown des produits
                 */
                var setDropdownProduits = function() {
                    $('#produits-dropdown-equip .menu').html('');
                    angular.forEach(scope.allCategsAndProducts, function(categData, categName) {
                        $('#produits-dropdown-equip .menu').append('<div class="ui horizontal divider">' + $filter('translate')(categName) + '</div>');
                        angular.forEach(categData, function(produit, key) {
                            if(scope.productsWithoutInventaire.indexOf(produit.nom) === -1) {
                                $('#produits-dropdown-equip .menu').append('<div class="item" data-value="' + produit.id + '">' + $filter('translate')(produit.nom) + '</div>');
                            }
                        });
                    });

                    $('#produits-dropdown-equip').dropdown();
                };

                /**
                 * Au submit
                 * @return void
                 */
                scope.onSubmit = function() {
                    scope.submit_loaded             = false;
                    scope.messages_error            = [];
                    var inputsName                  = [];
                    $('form input, form select, form textarea', element).each(function() {
                        var inputName = $(this).attr('name');
                        if(inputName !== undefined) {
                            inputsName.push(); // Récupère tous les noms des inputs du formulaire (même les listes vides)
                        }
                    });
                    var inputsArray                 = $('form', element).serializeArray();
                    var inputs                      = formatArrayForm(inputsArray, inputsName);
                    inputs['required_product_id']   = true;
                    var url                         = scope.editMode ? 'site/' + scope.siteid + '/equipments/'+ scope.equipement.id +'/update' : 'site/' + scope.siteid + '/equipments/create';

                    if (angular.isDefined(scope.associateproductid) && inputs['associate_product_id'] === undefined) {
                        inputs['associate_product_id'] = scope.associateproductid;
                    }

                    crudService.post(
                        url,
                        inputs,
                        {
                            error_code_ignore_modal: [500]
                        }
                    ).then(function(response) {
                        if(response.success !== undefined && !response.success) {
                            scope.messages_error = Array.isArray(response.message) ? response.message : [response.message]
                        } else {
                            $rootScope.$broadcast('form_equipement_done', response);
                        }
                        scope.submit_loaded = true;
                    }, function(error) {
                        scope.submit_loaded = true;
                        if (angular.isDefined(error.data) && angular.isDefined(error.data.messages)) {
                            scope.messages_error = error.data.messages;
                        }
                    });
                };

                /**
                 * Au clic sur le btn annuler
                 * @return void
                 */
                scope.onCancel = function() {
                    $('#type-equip-dropdown').val(null).trigger('change');
                    $('input[name="nom"]').val('');
                    $rootScope.$broadcast('form_add_equipement_cancel', {});
                };

                // Recuperation et bind de la dropdown types d'equipements
                crudService.get('types-equipement').then(function(response) {
                    scope.types_equipement_regroupements = response;
                    initDropDown();
                });                

                /**
                 * Détruit les signaux déjà existants
                 * Obligatoire car à chaque rechargement de la directive
                 * Les signaux sont dupliqués et donc appliqués autant de fois que de chargement
                 */
                $rootScope.destroySignals([
                    'DirectiveEquipement::resetMsgError',
                    'DirectiveEquipement::setEditMode',
                    'DirectiveEquipement::setEquipData'
                ]);
                
                /**
                 * Reset le message d'erreur
                 */
                $rootScope.$on('DirectiveEquipement::resetMsgError', function(e, data) {
                    if(data.reset) {
                        scope.messages_error = [];
                    }
                });

                /**
                 * Mode édition, true / false
                 */
                $rootScope.$on('DirectiveEquipement::setEditMode', function(e, data) {
                    scope.editMode = data.edit;
                });

                /**
                 * Initialise les données de l'équipement
                 */
                $rootScope.$on('DirectiveEquipement::setEquipData', function(e, data) {
                    resetForm();
                    scope.equipement = data.equipement;
                    // Si l'équipement n'est pas vide
                    if(Object.keys(scope.equipement).length > 0) {
                        $('input[name="nom"]').val(scope.equipement.nom); // Nom de l'équipement
                        // Si le produit est précisé
                        if(angular.isDefined(scope.equipement.produits) && scope.hasproducts) {
                            setTimeout(function() {
                                // Produit de l'équipement
                                $('#produits-dropdown-equip')
                                    .dropdown('set selected', scope.equipement.produits[0].id)
                                    .dropdown('refresh');                            
                            }, 0);
                        }
                        
                        // Type de l'équipement
                        $('#type-equip-dropdown')
                        .val(String(scope.equipement.type_equipement_id))
                        .trigger('change');
                    }
                });
                
                /**
                 * Réinitialise le formulaire de saisie
                 */
                function resetForm() {
                    $('input[name="nom"]').val(""); // Nom de l'équipement
                    setTimeout(function() { // Type de l'équipement
                        $('#produits-dropdown-equip')
                            .dropdown('clear')
                            .dropdown('refresh');

                        }, 0); 
                    $('#type-equip-dropdown')
                        .val(null)
                        .trigger('change');
                }
            }
        }
    }
]);
